import React from 'react'
import { Table } from '../table/table.jsx'
import { getRelativeAssetBasePath } from '../../../global/environments/path.js'

export const FormsAndAppTable = (documents) => {
  const getAspect = (section) => {
    const aspects = [
      {
        name: '#formsAndApplications',
        info: {
          columns: [
            {
              name: 'document',
              className: 'Table-header',
              ariaLabel: 'Document',
              content: <div>Document</div>,
              button: {
                className: 'Table-headerNode u-padding2gu u-paddingRight4gu',
                sort: 'title',
                sortType: 'string',
              },
              cell: {
                content: (document) => (
                  <>
                    {document.link?.Link[0]._meta.mirror?.path ? (
                      <a
                        href={
                          getRelativeAssetBasePath() +
                          '/' +
                          document.link?.Link[0]._meta.mirror?.path
                        }
                      >
                        {document.title}
                      </a>
                    ) : (
                      <p>{document.title}</p>
                    )}
                    <p>
                      {document.description.content
                        .replaceAll('<p>', '')
                        .replaceAll('</p>', '')
                        .replaceAll('&nbsp;', ' ')}
                    </p>
                  </>
                ),
              },
            },
            {
              name: 'productType',
              className: 'Table-header',
              ariaLabel: 'Product Type',
              content: <div className="u-textNoWrap">Product Type</div>,
              cell: {
                content: (document) => (
                  <p className="u-textCapitalize">
                    {document.productType.includes('closed-end')
                      ? document.productType.replace(/.*\./, '')
                      : document.productType
                          .replaceAll('-', ' ')
                          .replace(/.*\./, '')}
                  </p>
                ),
              },
            },
            {
              name: 'documentType',
              className: 'Table-header',
              ariaLabel: 'Document Type',
              content: <div className="u-textNoWrap">Document Type</div>,
              button: {
                className: 'Table-headerNode u-padding2gu u-paddingRight4gu',
                sort: 'documentType',
                sortType: 'string',
              },
              cell: {
                content: (document) => (
                  <p className="u-textCapitalize">
                    {document.documentType.replaceAll('-', ' ')}
                  </p>
                ),
              },
            },
          ],
        },
      },
    ]

    return aspects.find((a) => a.name === section).info
  }

  const aspect = getAspect('#formsAndApplications')

  return (
    <Table
      columns={aspect.columns}
      rows={documents?.length === 0 ? [] : documents.documents}
      emptyMessage={<strong>No matching results found.</strong>}
    />
  )
}
